export default __webpack_public_path__ + "87b550293fdd2d9fc2af4af1d8d9c833.png";